import { render, staticRenderFns } from "./IFProfitabilityVariance.vue?vue&type=template&id=539f68ec"
import script from "./IFProfitabilityVariance.vue?vue&type=script&lang=js"
export * from "./IFProfitabilityVariance.vue?vue&type=script&lang=js"
import style0 from "./IFProfitabilityVariance.vue?vue&type=style&index=0&id=539f68ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports